import React, { useId } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { MmcLabel } from './mmc_input';

const MmcSelect = ({
    label,
    icon: Icon = null,
    options = [],
    value,
    onChange,
    id,
    className = '',
    error,
    ...props
}) => {
    const generatedId = useId();
    const selectId = id || generatedId;
    const errorId = `${selectId}-error`;

    return (
        <div className="mmc-input-wrapper">
            {label && (
                <MmcLabel icon={Icon} htmlFor={selectId}>
                    {label}
                </MmcLabel>
            )}
            <div style={{ position: 'relative' }}>
                <select
                    id={selectId}
                    className={`mmc-input ${className}`}
                    value={value}
                    onChange={onChange}
                    style={{ appearance: 'none', paddingRight: '40px' }}
                    aria-invalid={!!error}
                    aria-describedby={error ? errorId : undefined}
                    {...props}
                >
                    {options.map(opt => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
                <CaretDown
                    size={16}
                    weight="bold"
                    style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none',
                        opacity: 0.5
                    }}
                    aria-hidden="true"
                />
            </div>
            {error && (
                <span id={errorId} className="mmc-input-error" role="alert">
                    {error}
                </span>
            )}
        </div>
    );
};

export default MmcSelect;
